import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "far fa-times" }, null, -1 /* HOISTED */);
const _hoisted_2 = [
    _hoisted_1
];
const _hoisted_3 = {
    key: 0,
    class: "catalog-filters__inner catalog-filters__inner--sidebar"
};
const _hoisted_4 = { key: 2 };
const _hoisted_5 = {
    key: 1,
    class: "catalog__filter catalog__filter--price"
};
const _hoisted_6 = { class: "filter" };
const _hoisted_7 = { class: "filter__title" };
const _hoisted_8 = { class: "filter__dropdown" };
const _hoisted_9 = {
    key: 1,
    class: "catalog-filters__inner catalog-filters__inner--header"
};
const _hoisted_10 = { key: 2 };
const _hoisted_11 = {
    key: 1,
    class: "catalog__filter catalog__filter--price"
};
const _hoisted_12 = { class: "filter filter--price-slider" };
const _hoisted_13 = { class: "catalog__header" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-sliders-h" }, null, -1 /* HOISTED */);
const _hoisted_15 = {
    key: 1,
    class: "catalog__ordering"
};
const _hoisted_16 = ["value"];
const _hoisted_17 = { value: "default" };
const _hoisted_18 = { value: "newest" };
const _hoisted_19 = { value: "alphabetic" };
const _hoisted_20 = { value: "mostSold" };
const _hoisted_21 = { value: "priceHighToLow" };
const _hoisted_22 = { value: "priceLowToHigh" };
const _hoisted_23 = { class: "catalog__items-wrapper" };
const _hoisted_24 = { class: "catalog__loadmore catalog__loadmore--less" };
const _hoisted_25 = { class: "catalog__loadmore" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FilterList = _resolveComponent("FilterList");
    const _component_PermalinkList = _resolveComponent("PermalinkList");
    const _component_PriceRangeSlider = _resolveComponent("PriceRangeSlider");
    const _component_Dropdown = _resolveComponent("Dropdown");
    const _component_CircularSpinner = _resolveComponent("CircularSpinner");
    const _component_CatalogItem = _resolveComponent("CatalogItem");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["catalog", `catalog--layout-${_ctx.config.layoutMode}`])
    }, [
        _createElementVNode("div", {
            ref: "sidebar",
            class: _normalizeClass(["catalog-filters", { 'catalog-filters--opened': _ctx.sidebarOpen }])
        }, [
            _createElementVNode("a", {
                class: "catalog-filters__close",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.sidebarOpen = false))
            }, _hoisted_2),
            (_ctx.config.layoutMode === 'sidebar' || _ctx.config.layoutMode === 'block')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.config.enableFilters)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('filterFor')), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxRefs, ([tax, taxRef]) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (taxRef.terms.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: tax,
                                            class: _normalizeClass(`catalog__filter catalog__filter--${tax}`)
                                        }, [
                                            (taxRef.options.type === 'checkbox')
                                                ? (_openBlock(), _createBlock(_component_FilterList, {
                                                    key: `${tax}-checkbox`,
                                                    taxonomy: tax,
                                                    title: taxRef.options.title,
                                                    terms: taxRef.terms,
                                                    "selected-terms": taxRef.selectedTerms,
                                                    "toggle-cb": _ctx.onFilterListToggleAndReload,
                                                    "max-depth": taxRef.options.maxDepth,
                                                    "full-open": taxRef.options.fullOpen
                                                }, null, 8 /* PROPS */, ["taxonomy", "title", "terms", "selected-terms", "toggle-cb", "max-depth", "full-open"]))
                                                : (taxRef.options.type === 'permalink')
                                                    ? (_openBlock(), _createBlock(_component_PermalinkList, {
                                                        key: `${tax}-permalink`,
                                                        taxonomy: tax,
                                                        title: taxRef.options.title,
                                                        terms: taxRef.terms,
                                                        "base-url": `${_ctx.config.baseUrl}/${taxRef.options.rewrite}`,
                                                        "max-depth": taxRef.options.maxDepth,
                                                        "full-open": taxRef.options.fullOpen
                                                    }, null, 8 /* PROPS */, ["taxonomy", "title", "terms", "base-url", "max-depth", "full-open"]))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(`Invalid filter type: ${taxRef.options.type}`), 1 /* TEXT */))
                                        ], 2 /* CLASS */))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                    (_ctx.config.enablePriceFilter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('price')), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_PriceRangeSlider, {
                                        min: _ctx.priceRange.min,
                                        max: _ctx.priceRange.max,
                                        selectedMin: _ctx.selectedPriceRange?.min ?? _ctx.priceRange.min,
                                        selectedMax: _ctx.selectedPriceRange?.max ?? _ctx.priceRange.max,
                                        onChange: _ctx.onPriceRangeSliderChangeAndReload
                                    }, null, 8 /* PROPS */, ["min", "max", "selectedMin", "selectedMax", "onChange"])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    (_ctx.config.enableFilters)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "catalog-filters__apply btn",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.sidebarOpen = false))
                        }, _toDisplayString(_ctx.$t('apply')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true),
            (_ctx.config.layoutMode === 'header')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.config.enableFilters)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.taxRefs, ([tax, taxRef]) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (taxRef.terms.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: tax,
                                        class: _normalizeClass(`catalog__filter catalog__filter--${tax}`)
                                    }, [
                                        _createVNode(_component_Dropdown, {
                                            ref_for: true,
                                            ref: _ctx.addDdRef,
                                            onToggle: _ctx.onDdToggle,
                                            title: taxRef.options.title,
                                            onApply: _ctx.onDdApplyFilters
                                        }, {
                                            default: _withCtx(() => [
                                                (taxRef.options.type === 'checkbox')
                                                    ? (_openBlock(), _createBlock(_component_FilterList, {
                                                        key: `${tax}-checkbox`,
                                                        taxonomy: tax,
                                                        terms: taxRef.terms,
                                                        "selected-terms": taxRef.selectedTerms,
                                                        "toggle-cb": _ctx.onFilterListToggle,
                                                        "max-depth": taxRef.options.maxDepth,
                                                        "full-open": taxRef.options.fullOpen
                                                    }, null, 8 /* PROPS */, ["taxonomy", "terms", "selected-terms", "toggle-cb", "max-depth", "full-open"]))
                                                    : (taxRef.options.type === 'permalink')
                                                        ? (_openBlock(), _createBlock(_component_PermalinkList, {
                                                            key: `${tax}-permalink`,
                                                            taxonomy: tax,
                                                            terms: taxRef.terms,
                                                            "base-url": `${_ctx.config.baseUrl}/${taxRef.options.rewrite}`,
                                                            "max-depth": taxRef.options.maxDepth,
                                                            "full-open": taxRef.options.fullOpen
                                                        }, null, 8 /* PROPS */, ["taxonomy", "terms", "base-url", "max-depth", "full-open"]))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(`Invalid filter type: ${taxRef.options.type}`), 1 /* TEXT */))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onToggle", "title", "onApply"])
                                    ], 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */));
                        }), 256 /* UNKEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                    (_ctx.config.enablePriceFilter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_Dropdown, {
                                ref: _ctx.addDdRef,
                                onToggle: _ctx.onDdToggle,
                                title: _ctx.$t('price'),
                                onApply: _ctx.onDdApplyPriceRange
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_PriceRangeSlider, {
                                            min: _ctx.priceRange.min,
                                            max: _ctx.priceRange.max,
                                            selectedMin: _ctx.selectedPriceRange?.min ?? _ctx.priceRange.min,
                                            selectedMax: _ctx.selectedPriceRange?.max ?? _ctx.priceRange.max,
                                            onChange: _ctx.onPriceRangeSliderChange
                                        }, null, 8 /* PROPS */, ["min", "max", "selectedMin", "selectedMax", "onChange"])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onToggle", "title", "onApply"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_13, [
            (_ctx.config.enableFilters)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "catalog-filters__button",
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.sidebarOpen = true))
                }, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('filterFor')), 1 /* TEXT */)
                ]))
                : _createCommentVNode("v-if", true),
            (_ctx.config.enableOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("select", {
                        value: _ctx.order,
                        onChange: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.onOrderSelectChange && _ctx.onOrderSelectChange(...args))),
                        name: "order",
                        id: "order"
                    }, [
                        _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('default')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('newest')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('alphabetic')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t('popularity')), 1 /* TEXT */),
                        _createCommentVNode(" <option value=\"mostRated\">Con più recensioni</option>\n            <option value=\"bestRated\">Con voto più alto</option> "),
                        _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('priceHighToLow')), 1 /* TEXT */),
                        _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t('priceLowToHigh')), 1 /* TEXT */)
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16)
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createVNode(_component_CircularSpinner, { size: 50 }, null, 512 /* NEED_PATCH */), [
                [_vShow, _ctx.loadingProducts]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_24, [
                _withDirectives(_createVNode(_component_CircularSpinner, { size: 25 }, null, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.loadingMoreProducts]
                ]),
                _withDirectives(_createElementVNode("a", {
                    class: "btn",
                    onClick: _cache[4] || (_cache[4] =
                        //@ts-ignore
                        (...args) => (_ctx.onLoadLessClick && _ctx.onLoadLessClick(...args)))
                }, _toDisplayString(_ctx.$t('showPrev')), 513 /* TEXT, NEED_PATCH */), [
                    [_vShow, !_ctx.loadingMoreProducts]
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, !_ctx.loadingProducts && _ctx.previousPage > 0]
            ]),
            _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["catalog__items products", `columns-${_ctx.config.columns}`])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, i) => {
                    return (_openBlock(), _createBlock(_component_CatalogItem, {
                        key: `product-${product.id}`,
                        host: _ctx.config.baseUrl,
                        product: product,
                        lang: _ctx.config.language,
                        "tax-applier": _ctx.taxApplier,
                        "show-add-to-cart-btn": _ctx.config.showAddToCartBtn,
                        "show-quantity-input": _ctx.config.showQuantityInput,
                        onAddToCart: ($event) => (_ctx.addToCartHandle($event, i)),
                        onViewDetails: ($event) => (_ctx.viewDetailsHandle($event, i)),
                        onAddToWishlist: ($event) => (_ctx.addToWishlistHandle($event, i))
                    }, null, 8 /* PROPS */, ["host", "product", "lang", "tax-applier", "show-add-to-cart-btn", "show-quantity-input", "onAddToCart", "onViewDetails", "onAddToWishlist"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */), [
                [_vShow, !_ctx.loadingProducts]
            ]),
            _withDirectives(_createElementVNode("h4", { class: "products__not_found" }, _toDisplayString(_ctx.$t('noProductsFound')), 513 /* TEXT, NEED_PATCH */), [
                [_vShow, !_ctx.loadingProducts && _ctx.products.length === 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_25, [
                _withDirectives(_createVNode(_component_CircularSpinner, { size: 25 }, null, 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.loadingMoreProducts]
                ]),
                _withDirectives(_createElementVNode("a", {
                    class: "btn",
                    onClick: _cache[5] || (_cache[5] =
                        //@ts-ignore
                        (...args) => (_ctx.onLoadMoreClick && _ctx.onLoadMoreClick(...args)))
                }, _toDisplayString(_ctx.$t('showMore')), 513 /* TEXT, NEED_PATCH */), [
                    [_vShow, !_ctx.loadingMoreProducts]
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, !_ctx.loadingProducts && _ctx.numberOfPages > _ctx.page]
            ])
        ])
    ], 2 /* CLASS */));
}
